import {
  ACCESS_CREDENTIALS_ROUTE,
  AccessCredentialsRouteAction,
  BUCKETS_ROUTE,
  DefaultRouteAction,
  getAbsoluteRoute,
  GROUPS_ROUTE,
  LOGIN_ROUTE,
  LOGOUT_SUCCESS_ROUTE,
  MFARouteAction,
  POLICIES_ROUTE,
  SETTINGS_ROUTE,
  SHARD_CLUSTERS_ROUTE,
  SHARD_REPOSITORIES_ROUTE,
  STORAGE_PROVIDERS_ROUTE,
  StorageProviderRouteParam,
  USERS_ROUTE,
} from "../constants/routes";

export class RouteUtils {
  getRouteToLogoutSuccessPage() {
    return LOGOUT_SUCCESS_ROUTE;
  }

  getRouteToShardClusterList() {
    return getAbsoluteRoute(SHARD_CLUSTERS_ROUTE);
  }

  getRouteToStorageProviderList() {
    return getAbsoluteRoute(STORAGE_PROVIDERS_ROUTE);
  }

  getRouteToShardClusterDetails(id: string) {
    return `/${SHARD_CLUSTERS_ROUTE}/${id}`;
  }

  getRouteToNewShardCluster(): string {
    return `/${SHARD_CLUSTERS_ROUTE}/${DefaultRouteAction.New}`;
  }
  getRouteToNewStorageProvider(): string {
    return `/${STORAGE_PROVIDERS_ROUTE}/${DefaultRouteAction.New}`;
  }
  getRouteToStorageProviderTemplate(): string {
    return `/${STORAGE_PROVIDERS_ROUTE}/${StorageProviderRouteParam.Template}`;
  }
  getRouteToStorageProviderDetails(id: string): string {
    return `/${STORAGE_PROVIDERS_ROUTE}/${id}`;
  }

  getRouteToAccessCredentialList(): string {
    return getAbsoluteRoute(ACCESS_CREDENTIALS_ROUTE);
  }

  getRouteToNewAccessCredentials(): string {
    return `/${ACCESS_CREDENTIALS_ROUTE}/${AccessCredentialsRouteAction.AddCredentials}`;
  }

  getRouteToNewBucket(): string {
    return ["", BUCKETS_ROUTE, DefaultRouteAction.New].join("/");
  }

  getRouteToBucketList() {
    return getAbsoluteRoute(BUCKETS_ROUTE);
  }

  getRouteToBucketDetails(id: string) {
    return ["", BUCKETS_ROUTE, id].join("/");
  }

  getRouteToIAMUserDetails(id: string) {
    return ["", USERS_ROUTE, id].join("/");
  }
  getRouteToNewIAMUser(): string {
    return ["", USERS_ROUTE, DefaultRouteAction.New].join("/");
  }
  getRouteToIAMUserList() {
    return getAbsoluteRoute(USERS_ROUTE);
  }
  getRouteToIAMGroupDetails(id: string) {
    return ["", GROUPS_ROUTE, id].join("/");
  }
  getRouteToNewIAMGroup(): string {
    return ["", GROUPS_ROUTE, DefaultRouteAction.New].join("/");
  }
  getRouteToIAMGroupList() {
    return getAbsoluteRoute(GROUPS_ROUTE);
  }
  getRouteToIAMPolicyDetails(arn: string) {
    return ["", POLICIES_ROUTE, encodeURIComponent(arn)].join("/");
  }
  getRouteToNewIAMPolicy(): string {
    return ["", POLICIES_ROUTE, DefaultRouteAction.New].join("/");
  }
  getRouteToIAMPolicyList() {
    return getAbsoluteRoute(POLICIES_ROUTE);
  }

  getRouteToShardRepositoryList(): string {
    return getAbsoluteRoute(SHARD_REPOSITORIES_ROUTE);
  }

  getRouteToNewShardRepository(): string {
    return ["", SHARD_REPOSITORIES_ROUTE, DefaultRouteAction.New].join("/");
  }

  getRouteToShardRepositoryDetails(id: string) {
    return ["", SHARD_REPOSITORIES_ROUTE, id].join("/");
  }

  getRouteToSignInForm() {
    return LOGIN_ROUTE;
  }

  getRouteToMfaVerification() {
    return ["", SETTINGS_ROUTE, MFARouteAction.Verification].join("/");
  }
}

export const routeUtils = new RouteUtils();
